import React, { useState, useEffect, useRef } from 'react';
import "../Layout/Layout.css";
import "../Layout/product2.css";
function Product2({ product }) {

const [windowWidth, setWindowWidth] = useState(window.innerWidth);
useEffect(() => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);
const unit =[
  {id:1,product:1,unit:"Hộp",price:234000,note:"Hộp 15 vỉ"},
  {id:2,product:1,unit:"Vỉ",price:15600,note:"Vỉ 12 viên"},
  {id:3,product:2,unit:"Hộp",price:51990,note:"Hộp 4 vỉ"},
  {id:4,product:2,unit:"Vỉ",price:12998,note:"Vỉ 4 viên"},
  {id:5,product:3,unit:"Hộp",price:47000,note:"Hộp 20 gói"},
  {id:6,product:3,unit:"Gói",price:1958,note:"Hộp 20 gói"},
  {id:7,product:4,unit:"Hộp",price:194000,note:"Hộp 5 vỉ"},
  {id:8,product:4,unit:"Vỉ",price:38800,note:"Vỉ 10 viên"},
  {id:9,product:5,unit:"Hộp",price:112500,note:"Hộp 25 vỉ"},
  {id:10,product:5,unit:"Gói",price:4500,note:"Vỉ 4 gói"},
  {id:11,product:6,unit:"",price:0,note:"Hộp 10 vỉ x 4 viên"},
  {id:12,product:7,unit:"",price:0,note:"Hộp 3 vỉ x 10 viên"},
  {id:13,product:8,unit:"",price:0,note:"Hộp 2 vỉ x 10 viên"},
  {id:14,product:9,unit:"",price:0,note:"Hộp 5 vỉ x 10 viên"},
  {id:15,product:10,unit:"",price:0,note:"Hộp 4 vỉ x 10 viên"},
  {id:16,product:11,unit:"Hộp ",price:240000,note:"Hộp 24 gói"},
  {id:17,product:11,unit:"Gói",price:10000,note:"Gói x 10ml"},
  {id:18,product:12,unit:"Hộp ",price:126000,note:"Hộp 20 gói"},
  {id:19,product:12,unit:"Gói",price:6300,note:"Gói x 15ml"},
];
const img =[
  {id:1,item1:"11.jfif",item2:"12.jfif",item3:"13.jfif",item4:"14.jfif",item5:"15.jfif",},
  {id:2,item1:"21.jfif",item2:"22.jfif",item3:"23.jfif",item4:"24.jfif",item5:"25.jfif",},
  {id:3,item1:"31.jfif",item2:"32.jfif",item3:"33.jfif",item4:"34.jfif",item5:"35.jfif",},
  {id:4,item1:"41.jfif",item2:"42.jfif",item3:"43.jfif",item4:"44.jfif",item5:"45.jfif",},
  {id:5,item1:"51.jfif",item2:"52.jfif",item3:"53.jfif",item4:"54.jfif",item5:"55.jfif",},
  {id:6,item1:"61.webp",item2:"62.webp",item3:"63.webp",item4:"64.webp",item5:"65.webp",},
  {id:7,item1:"71.jfif",item2:"72.jfif",item3:"73.jfif",item4:"74.jfif",item5:"75.jfif",},
  {id:8,item1:"81.jfif",item2:"82.jfif",item3:"83.jfif",item4:"84.jfif",item5:"85.jfif",},
  {id:9,item1:"91.jfif",item2:"92.jfif",item3:"93.jfif",item4:"94.jfif",item5:"95.jfif",},
  {id:10,item1:"101.jpg",item2:"",item3:"",item4:"",item5:"",},
  {id:11,item1:"111.jfif",item2:"11.jfif",item3:"113.jfif",item4:"114.jfif",item5:"115.jfif",},
  {id:12,item1:"121.jfif",item2:"122.jfif",item3:"123.jfif",item4:"124.jfif",item5:"125.jfif",},
];
 //name tên loại thuốc , l1 thuốc hay thiết bị... l2 loại thuốc nào
 // l1:1 thuốc
 // l2:1 Thuốc Giảm đau - Hạ sốt
const class1=[
  {name:"Thuốc Giảm đau - Hạ sốt",l1:1,l2:1},
  {name:"Thuốc Tiêu hóa - Dạ dày",l1:1,l2:2},
  {name:"Thuốc Bổ - Vitamin",l1:1,l2:3},
  {name:"Thuốc Bôi ngoài da và dán",l1:1,l2:4},
  {name:"Thuốc Mắt - Mũi - Họng",l1:1,l2:5},
  {name:"Thuốc Tim mạch - Huyết áp",l1:1,l2:6},
  {name:"Thuốc Rối Loạn LIPID Huyết (Mỡ máu)",l1:1,l2:7},
  {name:"Thuốc tiểu đường (Đái Tháo Đường)",l1:1,l2:8},
  {name:"Thuốc Cơ Xương Khớp",l1:1,l2:9},
  {name:"Thuốc Dị ứng",l1:1,l2:10},
  {name:"Thuốc Kháng sinh - Kháng nấm (Rx)",l1:1,l2:11},
  {name:"Thuốc Miếng dán cao xao - Dầu gió",l1:1,l2:12},
  {name:"Chăm sóc da mặt",l1:2,l2:13},
  {name:"Chăm sóc cơ thể",l1:2,l2:14},
  {name:"Chăm sóc làn da",l1:2,l2:15},
  {name:"Dụng cụ y thế",l1:3,l2:16},
  {name:"Dụng cụ theo dõi",l1:3,l2:17},
  {name:"Dụng cụ sơ cứu",l1:3,l2:18},
  {name:"Khẩu trang",l1:3,l2:19},

]
const class2=[
  {name:"Thuốc không kê đơn",id:1},
  {name:"Thuốc kê đơn",id:2},
]

const isScreen = windowWidth > 768;
const content = isScreen ? <Desktop product={product} unit={unit} img={img} class1={class1} class2={class2}/> : <Mobile />;

return (
  <body style={{background:"#fff"}}>
    {content}
  </body>
);
};
const Desktop = ({product,unit,img,class1,class2}) => {
  const [clickedunit, setClickedunit] = useState(null);
  const units = unit.filter((unit) => unit.product === product.id);
  const firstUnitId = units.length > 0 ? units[0].id : null;
  const [selectedColor, setSelectedColor] = useState(firstUnitId);
  const id = product.id;
  ;
  const handleColorChange = (unit) =>{
    setClickedunit(unit);
    setSelectedColor(unit);
  };
return (
  <body class='form-product2' key={product.id} >
          <div class='form-product-head'>
            {img.filter(img =>  img.id == product.img).map(img =>
              <img src={`/imges/${img.item1}`} alt=''></img>
            )}
          </div>
          <div class='form-product-body'>
            <div class='form-product-body-name'>  
              <span>{product.name}</span>
            </div>
            <div class='form-product-body-price'>
              {(product.class2 === 1)?
                <>
                  <div>
                    {(clickedunit === null)?
                      unit.filter(unit =>  unit.product === product.id).slice(0, 1).map(unit =>
                        <>
                          <h4>{unit.price.toLocaleString('vi-VN') + "đ / " + unit.unit}</h4>
                          <div style={{display:"flex",height:"60px"}}>
                            <p>{unit.note}</p>
                          </div>
                          
                        </>
                      )
                      :
                      unit.filter(unit =>  (unit.id === clickedunit)).map(unit =>
                        <>
                          <h4>{unit.price.toLocaleString('vi-VN') + "đ / " + unit.unit}</h4>
                          <div style={{display:"flex"}}>
                            <p>{unit.note}</p>
                          </div>
                        </>
                      )
                    }
                  </div>
                </>
                :
                <>
                {unit.filter(unit =>  unit.product === product.id).map(unit =>
                  <div>
                    <h4>Cần tư vấn từ dược sĩ</h4>
                    <p >{unit.note}</p>
                  </div>
                )}
                </>
              }
            </div>
          </div>    
  </body>
 );
};
const Mobile = () => {
return (
  <body>
     
  </body>
);
};
export default Product2;



